/**
 * EventsMobileFooter Section Component
 *
 * Mobile global footer for the events listing, mirroring OrdersMobileFooter:
 * a full-width salesperson filter trigger. The date filter now has its own
 * trigger row above the mobile card list (see AllEventsPage), so this footer
 * is salesperson-only.
 */

// Shared components
import { cn } from '@/lib/utils';
import { MobilePillButton } from '../../layouts/MobileButtons';

// Hooks
import { useTranslation } from '@hooks/useTranslation';

// Types
import type { EventsMobileFooterProps } from '../types';

export type { EventsMobileFooterProps };

export function EventsMobileFooter({ onOpenSalespersonFilter, className }: EventsMobileFooterProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex w-full px-6 py-6', className)}>
      <MobilePillButton
        onClick={onOpenSalespersonFilter}
        className="w-full justify-center text-nav"
      >
        {t('toolbar.salesperson')}
      </MobilePillButton>
    </div>
  );
}
